<template>
  <div class="tableshow-student">
    <div class="student-left-box">
      <div class="name">课程班级名称</div>
      <div class="student-left smart-scroll">
        <div
          v-for="(item, index) in classList"
          :key="index"
          class="student-left-item"
          :class="index === activeClassIndex ? 'student-left-item-active' : ''"
          @click="handleChangeClass(index)"
        >
          <!-- <Tooltip max-width="200" :content="`${item.className}（${item.studentInfos.length}人）`">
            <div class="name-content"><span class="left-name">{{ item.className }}</span><span>（{{ item.studentInfos.length }}人）</span></div>
          </Tooltip> -->
          <div class="name-content">
            <span class="left-name">{{ item.className }}（{{ item.studentInfos.length }}人）</span>
          </div>
        </div>
      </div>
    </div>
    <!-- <div v-if="loading" class="student-right">
      <Spin></Spin>
    </div> -->
    <div class="student-right">
      <div class="student-right-top">
        <Input
          v-model="classList[activeClassIndex].className"
          class="classname-input"
          placeholder="请输入课班名称"
        ></Input>
        <div class="info-block">
          <ChooseTeacherForForm
            :show-handle-icon="true"
            :school-id="schoolId"
            :apply-id="orgId"
            :parent-teacher-list="classList[activeClassIndex].teacherInfo"
            @postTeacherData="getSelectTeacherData"
          ></ChooseTeacherForForm>
        </div>
        <div class="info-block">
          <span class="info-block-title">上课场地:</span>
          <div class="info-block-content">
            <PlaceSelect
              v-model="classList[activeClassIndex].placeInfo"
              class="class-form-item"
              :org-id="schoolId"
              :branch-id="branchId"
            ></PlaceSelect>
            <!-- <PlaceModal v-model="classList[activeClassIndex].placeInfo" :show-handle-icon="true" :org-id="schoolId" :should-classroom-id="false" :branch-id="branchId"></PlaceModal> -->
          </div>
        </div>
        <div class="info-block">
          <span class="info-block-title">上课时间:</span>
          <span class="info-block-content">
            <Tooltip
              max-width="150"
              :content="classList[activeClassIndex].timeDesc"
            >
              <span>{{ classList[activeClassIndex].timeDesc }}</span>
            </Tooltip>
          </span>
        </div>
      </div>
      <div class="student-select-all">
        <Checkbox
          :indeterminate="indeterminate"
          :value="checkAll"
          @click.prevent.native="handleCheckAll"
        >全选</Checkbox>
        <Button type="primary" @click="handleBatchChangeClass">批量转班</Button>
      </div>
      <div class="student-right-box">
        <div class="student-right-content smart-scroll">
          <CheckboxGroup
            v-model="checkAllGroup"
            @on-change="checkAllGroupChange"
          >
            <div
              v-for="(value, key) in classList[activeClassIndex]
                .classStudentInfo"
              :key="key"
              class="student-table-grop"
            >
              <div
                v-for="item in value.list"
                :key="item.studentId"
                :class="
                  searchStudentId === item.studentId
                    ? 'student-table-item-active'
                    : ''
                "
                class="student-table-item"
              >
                <div class="table-item-left">
                  <Checkbox :label="item.studentId"><div></div></Checkbox>
                </div>
                <div class="table-item-center">
                  {{ item.studentName }}（{{ item.gradeName
                  }}{{ item.className }}）
                </div>
                <div
                  class="table-item-right"
                  @click.stop="handleToChangeClass(item.studentId)"
                >
                  转班
                </div>
              </div>
            </div>
          </CheckboxGroup>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PlaceSelect from '@pv/courseSchedulCenter/assets/components/PlaceSelect.vue';
import ChooseTeacherForForm from '@c/searchBlock/ChooseTeacherForForm.vue';
export default {
  components: {
    // PlaceModal,
    ChooseTeacherForForm,
    PlaceSelect
  },
  props: {
    // 选中班级
    activeClassIndex: {
      type: Number,
      default: 0
    },
    // 商品列表选中的index变化之后
    activeGoodsIndex: {
      type: Number,
      default: 0
    },
    value: {
      type: Array,
      default: () => []
    }, // v-model的值
    searchStudentId: {
      type: String,
      default: ''
    },
    schoolId: {
      type: String,
      default: ''
    }, // 学校id
    branchId: {
      type: String,
      default: ''
    }, // 校区id
    orgId: {
      type: String,
      default: ''
    } // 资源提供方id
  },
  data() {
    return {
      indeterminate: false,
      checkAll: false,
      checkAllGroup: [],
      loading: false
    };
  },
  computed: {
    classList: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit('input', newVal);
      }
    }
  },
  watch: {
    activeGoodsIndex() {
      this.$emit('update:activeClassIndex', 0);
      this.indeterminate = false;
      this.checkAll = false;
      this.checkAllGroup = [];
    },
    activeClassIndex(newVal, oldval) {
      console.log(newVal, oldval, '选中的变化了-----');
    }
  },
  methods: {
    handleCheckAll() {
      if (this.indeterminate) {
        this.checkAll = false;
      } else {
        this.checkAll = !this.checkAll;
      }
      this.indeterminate = false;

      if (this.checkAll) {
        this.checkAllGroup = this.classList[this.activeClassIndex].studentInfos.map(item => {
          return item.studentId;
        });
      } else {
        this.checkAllGroup = [];
      }
    },
    checkAllGroupChange(data) {
      if (data.length === this.classList[this.activeClassIndex].studentInfos.length) {
        this.indeterminate = false;
        this.checkAll = true;
      } else if (data.length > 0) {
        this.indeterminate = true;
        this.checkAll = false;
      } else {
        this.indeterminate = false;
        this.checkAll = false;
      }
    },
    handleChangeClass(index) {
      this.loading = true;
      // this.$emit('update:activeClassIndex', index);
      // this.classList = this.classList.map(item => {
      //   item.teacherInfo = item.teacherInfoCopy;
      //   // item.placeInfo = item.placeInfoCopy;
      //   return item;
      // });
      this.$emit('update:activeClassIndex', index);
      this.indeterminate = false;
      this.checkAll = false;
      this.checkAllGroup = [];
      this.loading = false;
    },
    handleBatchChangeClass() {
      if (this.checkAllGroup.length === 0) {
        this.$Message.error('请至少选择一个要转班的学生！');
        return;
      }
      this.$emit('showChangeModal', this.checkAllGroup);
    },
    // 转班
    handleToChangeClass(studentId) {
      this.$emit('showChangeModal', [studentId]);
    },
    getSelectTeacherData(list) {
      this.classList[this.activeClassIndex].teacherIds = list.map(item => {
        return item.userId;
      });
      this.classList[this.activeClassIndex].teacherInfo = list.map(item => {
        return {
          teacherId: item.userId,
          teacherName: item.userName
        };
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.smart-scroll {
  scrollbar-width: thin; //火狐滚动条无法自定义宽度，只能通过此属性使滚动条宽度变细
  &::-webkit-scrollbar {
    width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 4px;
  }
  &::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    width: 4px;
    height: 60px;
    background: rgba(0, 0, 0, 0.15);
  }
  &::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    background: rgba(255, 255, 255, 0);
  }
}
.tableshow-student {
  height: calc(100% - 48px);
  padding-right: 24px;
  box-sizing: border-box;
  display: flex;
  .student-left-box {
    width: 240px;
    height: 100%;
    border: 1px solid #dcdee2;
    .name {
      height: 45px;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 600;
      border-bottom: 1px solid #dcdee2;
    }
  }
  .student-left {
    width: 100%;
    height: calc(100% - 45px);
    overflow-y: auto;
    border-radius: 2px;
    margin-right: 24px;
    .student-left-item {
      box-sizing: border-box;
      padding: 16px;
      min-height: 48px;
      display: flex;
      align-items: center;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 20px;
      cursor: pointer;
      .name-content {
        display: flex;
        align-items: center;
      }
      // .left-name{
      //   max-width: 180px;
      //   word-break: break-all;
      //   text-overflow: ellipsis;
      //   display: -webkit-box;
      //   -webkit-box-orient: vertical;
      //   -webkit-line-clamp: 1;
      //   overflow: hidden;
      // }
    }
    .student-left-item-active {
      font-weight: 600;
      color: #488ffa;
    }
    .student-left-item:hover {
      background: #efecfd;
    }
  }
  .student-right {
    flex: 1;
    height: 100%;
    border: 1px solid #dcdee2;
    display: flex;
    flex-direction: column;
    .student-right-top {
      display: flex;
      padding: 6px 8px;
      align-items: center;
      background: #f7f7f9;
      .classname-input {
        width: 25%;
      }
      .info-block {
        width: 20%;
        margin-left: 5%;
        overflow: hidden;
        display: flex;
        align-items: center;
        .info-block-title {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 20px;
          margin-right: 8px;
        }
        .info-block-content {
          flex: 1;
          span {
            word-break: break-all;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
          }
        }
      }
    }
    .student-select-all {
      height: 48px;
      border-top: 1px solid #dcdee2;
      border-bottom: 1px solid #dcdee2;
      padding-left: 8px;
      padding-right: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .student-right-box {
      height: calc(100% - 92px);
      .student-right-content {
        height: 100%;
        overflow-y: auto;
        position: relative;
        // .student-select-all{
        //   height: 48px;
        //   border-top: 1px solid #DCDEE2;
        //   border-bottom: 1px solid #DCDEE2;
        //   padding-left: 8px;
        //   padding-right: 16px;
        //   display: flex;
        //   justify-content: space-between;
        //   align-items: center;
        // }
        .student-table-grop + .student-table-grop {
          border-top: 1px solid #dcdee2;
        }
        .student-table-item + .student-table-item {
          border-top: 1px solid #dcdee2;
        }
        .student-table-grop:nth-last-of-type(1) {
          border-bottom: 1px solid #dcdee2;
        }
        .student-table-item-active {
          background: #efecfd;
          color: #488ffa;
        }
        // .student-table-item:hover{
        //   background: #EFECFD;
        //   color: #488ffa;
        // }
        .student-table-item {
          display: flex;
          height: 48px;
          cursor: pointer;
          .table-item-left {
            box-sizing: border-box;
            width: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-right: 1px solid #dcdee2;
            /deep/.ivu-checkbox-wrapper {
              margin-right: 0;
            }
          }
          .table-item-center {
            padding-left: 16px;
            display: flex;
            align-items: center;
            flex: 1;
          }
          .table-item-right {
            border-left: 1px solid #dcdee2;
            width: 118px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #488ffa;
            line-height: 20px;
          }
        }
      }
    }
  }
  .class-form-item {
    width: 120px;
  }
  // .info-block-content{
  //   word-break: break-all;
  //   text-overflow: ellipsis;
  //   display: -webkit-box;
  //   -webkit-box-orient: vertical;
  //   -webkit-line-clamp: 1;
  //   overflow: hidden;
  // }
}
</style>
